import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class DistanceSummaryGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var distanceSummaryGrid = this;
		setTimeout(function(){
			distanceSummaryGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var distanceSummaryGrid = this;
	
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							distanceSummaryGrid.actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DISTANCE_SUMMARIES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DISTANCE_SUMMARIES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DISTANCE_SUMMARIES:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toogle Status')						
					],
					listeners: {
						click: function() {
							actionUpdateStatus(grid.selectedItems);
						}
					}					
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['DISTANCE_SUMMARIES:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['DISTANCE_SUMMARIES:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tractorRefNo',
					header: 'Tractor Ref No',
					width: '7em'
				},
				{						
					path: 'periodEndUtcDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.periodEndUtcDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stateProvCode',
					header: 'State',
					width: '7em'
				},
				{						
					path: 'countryCode',
					header: 'Country',
					width: '7em'
				},
				{						
					path: 'travelDistance',
					header: 'Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'tollDistance',
					header: 'Toll Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'ferryDistance',
					header: 'Ferry Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'distanceUom',
					header: 'Distance UOM',
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				var distance = record.travelDistance ? record.travelDistance : 0;
				var toll = record.tollDistance ? record.tollDistance : 0;
				var ferry = record.ferryDistance ? record.ferryDistance : 0;
				
				if (record.distanceUom === 'KM') {
					totalDistance += UOMUtil.convertKMToMI(distance);
					totalToll += UOMUtil.convertKMToMI(toll);
					totalFerry += UOMUtil.convertKMToMI(ferry);
				} else {
					totalDistance += distance;
					totalToll += toll;
					totalFerry += ferry;
				}
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;						
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					}
					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
					ElementUtil.query(toolbar, 'updateStatus').disabled = true;				
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Displayed Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'summaries',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					DataManagementService.getDistanceSummaryService().exportDistanceSummaries(grid.currentFilter);					
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(distanceSummaryGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(distanceSummaryGrid.toolbarFilter, 'filterEndDate').value);			
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'periodEndUtcDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							status: ElementUtil.query(distanceSummaryGrid.toolbarFilter, 'status').value,	
							start: startFilterDts,													
							end: endFilterDts,
							filterField: 'tractorId',
							filterValue: ElementUtil.query(distanceSummaryGrid.toolbarFilter, 'filterTractorId').value, 
							dateField: 'periodEndUtcDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals = calcTotals(records.data);					
							distanceStatus.innerHTML = '<b>Displayed Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						
						DataManagementService.getDistanceSummaryService().getDistanceSummaries(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footerContainer
			]
		});		
		distanceSummaryGrid.append(flexLayout);	

		distanceSummaryGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionAddEdit = function(record) {
		
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Summary' : 'Add Summary',
				icon: 'vaadin:edit',				
				width: 700,
				height: 470,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits('TRACTOR', paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											itemid: 'tractorId',
											label: 'Tractor',
											name: 'tractorId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'tractorId');
														loadReferenceNo(ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Date(mm/dd/yyyy hh:mm:ss)',
											name: 'periodEndUtcDts',
											step: 1,
											required: true
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'stateProvCodeCB',
											label: 'State/Providence',
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
													combo.items = data;
												});
											}
										},										
										{
											tag: 'vaadin-number-field',												
											name: 'travelDistance',
											label: 'Distance',
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-number-field',												
											name: 'tollDistance',
											label: 'Toll Distance',
											required: true,
											value: 0,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-number-field',												
											name: 'ferryDistance',
											label: 'Ferry Distance',										
											required: true,
											value: 0,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'uomCB',
											label: 'UOM',
											name: 'distanceUom',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'MI',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DistanceUOM').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',											
											maxLength: 255											
										},											
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {			
																														
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;									
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {																	
																	data.countryCode = ElementUtil.query(formPanel, 'stateProvCodeCB').selectedItem.country;
																	data.taxable = true;															
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.tractorMileageId = record.tractorMileageId;
																	}																	
																	
																	return DataManagementService.getDistanceSummaryService().saveDistanceSummary(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Distance Summary', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	distanceSummaryGrid.actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var updateTractorCB = function() {
							var tractorIdFilter = ElementUtil.query(distanceSummaryGrid.toolbarFilter, 'filterTractorId').selectedItem;
							var initialValue = null;
							if (tractorIdFilter) {
								initialValue = tractorIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'tractorId');	
							loadReferenceNo(initialValue, refNoCB, function(cb) {
								if (tractorIdFilter) { 
									refNoCB.value = tractorIdFilter.code;
								}
							});
						};
						
						if (record) {								
							//wait for render;shift to end of event loop
							setTimeout(function() {
								formPanel.load(record);																							
								updateTractorCB();		
							});
						} else {
							updateTractorCB();							
						}
					}
				}
			});			
			
		};
		
		var actionUpdateStatus = function(records) {
			
			var multipleIds = {
				ids: []
			};
			var activate = false;
			records.forEach(function(record){
				if (record.activeStatus === 'I') {
					activate = true;
				}
				multipleIds.ids.push(
					record.tractorMileageId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Update',
				message: 'Are you sure you want to <b>' + (activate ? 'Activate' : 'Inactivate') + '</b> selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Updating Status...');

							var successCallback = function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Updated: ' + multipleIds.ids.length + ' records', {									
									theme: 'success'
								});
								distanceSummaryGrid.actionRefresh();
							};

							if (activate) {
								DataManagementService.getDistanceSummaryService().activateDistanceSummaries(multipleIds)
								.then(function(){
									successCallback();
								});						
							} else {
								DataManagementService.getDistanceSummaryService().inactivateDistanceSummaries(multipleIds)
								.then(function(){
									successCallback();
								});
							}
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.tractorMileageId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDistanceSummaryService().deleteDistanceSummaries(multipleIds)
							.then(function(result){
								loadMask.remove();
								window.DL.MessageUtil.showDeleteRecordsResult(result);
								distanceSummaryGrid.actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
			
			
		};
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'DISTANCE_SUMMARY',				
				uploadUrl: '/api/resource/distance-summaries/import'
			});
		};		
		
	}
	
	refreshGrid() {
		var distanceSummaryGrid = this;		
		distanceSummaryGrid.actionRefresh();
	}
	
	setFilterContainer(filterContainer) {
		var distanceSummaryGrid = this;		
		distanceSummaryGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-distance-summary-grid', DistanceSummaryGrid);